import debug from 'debug'

const logger = debug('publish:debug')

/**
 * Logs debug messages based on the environment and debug settings.
 *
 * Debug mode is enabled under these conditions:
 * - Development environment:
 *   - Both window.DEBUG and localStorage.debug must not be false
 * - Production environment:
 *   - Either window.DEBUG or localStorage.debug must be true
 *
 * @param values - Values passed to the debug logger
 * @example
 * debugLog('User data:', userData); // Logs when the debug settings enable it
 */
export function debugLog(...values: unknown[]): void {
  const isDev = process.env.NODE_ENV === 'development'
  const windowDebug = window.DEBUG
  const localStorageDebug = localStorage.getItem('debug')

  const isEnabled = isDev
    ? windowDebug !== false && localStorageDebug !== 'false'
    : windowDebug === true || localStorageDebug === 'true'

  logger.enabled = isEnabled
  if (!isEnabled) return

  const [firstValue, ...remainingValues] = values
  logger(firstValue, ...remainingValues)
}
